import React, { useState } from 'react';
import api from '../../api/api';
import { Backdrop, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { getPracticeId } from '../../config/practice';

const PrivilagesView = ({ data, user,  fetchPriviData,  setAlertMessage,
  setOpen,
  setSeverity}) => {
  const initialPermissions = JSON.parse(user?.permissions || '[]').map(String);
  const [selectedPermissions, setSelectedPermissions] = useState(initialPermissions);
const [loading,setLoading]=useState(false)
 const userConfig = useSelector((state) => state.userconfig);
  // Group data by page
  const grouped = data.reduce((acc, item) => {
    if (!acc[item.page]) acc[item.page] = [];
    acc[item.page].push(item);
    return acc;
  }, {});

  // Toggle individual privilege
  const togglePermission = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((perm) => perm !== id) : [...prev, id]
    );
  };

  // Toggle all privileges in a group
  const toggleSelectAll = (privileges) => {
    const ids = privileges.map((p) => String(p.id));
    const allSelected = ids.every((id) => selectedPermissions.includes(id));

    setSelectedPermissions((prev) =>
      allSelected
        ? prev.filter((id) => !ids.includes(id)) // unselect all
        : Array.from(new Set([...prev, ...ids])) // select all
    );
  };

  // Handle update click
  const handleUpdate = async() => {
setLoading(true)
    try {
        const response = await api.put(`/v1/${getPracticeId()}/user`, {
     email:user.email||'',
     rowid:user.id,
      permissions: selectedPermissions,
    });
    if(response.status==200){
      setAlertMessage('Privileges Updated Successfully')
      setSeverity('success')
      setOpen(true)
 fetchPriviData(true)
    }else{
   setAlertMessage(response?.message)
      setSeverity('info')
      setOpen(true)
    }

     
    } catch (error) {
         setAlertMessage('Something Went Wrong')
      setSeverity('error')
      setOpen(true)
        console.log(error)
    }finally{
setLoading(false)
    }
  };
  console.log(userConfig.role)

  return (
    <>
{  !['7', "6", "8", "9"].includes(
    userConfig.grole
  )&&<div className="flex items-start gap-2 rounded-[12.75px] border border-[#FEE685] mt-4 bg-[#F1F5F9] shadow-[0_1px_3px_0_rgba(0,0,0,0.10),0_1px_2px_-1px_rgba(0,0,0,0.10)] p-4 text-left">
  {/* Icon */}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 text-[#C2410C] mt-[2px]"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 15v-3m0 0V9m0 3h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 
      9-9 9 4.03 9 9z"
    />
  </svg>

  {/* Text */}
  <div>
    <p className="font-medium text-[#C2410C]">Admin Access Required</p>
    <p className="text-sm text-gray-700">
      You need administrator privileges to modify user permissions. Contact your
      system administrator to change privilege settings.
    </p>
  </div>
</div>}


    <div className="space-y-6 mt-4">
      {Object.entries(grouped).map(([page, privileges]) => {
        const allSelected = privileges.every((priv) =>
          selectedPermissions.includes(String(priv.id))
        );

        return (
       <div
          key={page}
          className={`rounded-xl border border-gray-200 bg-white p-6 shadow-sm ${
            !['7', '6', '8', '9'].includes(userConfig.grole) ? 'opacity-60' : ''
          }`}
        >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-sm font-semibold text-gray-800">{page} Privileges</h3>
              <label className="inline-flex items-center space-x-2 text-sm text-gray-600 cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox text-blue-600"
                     disabled={!['7', '6', '8', '9'].includes(userConfig.grole)}
                  checked={allSelected}
                  onChange={() => toggleSelectAll(privileges)}
                />
                <span>{allSelected ? 'Unselect all' : 'Select all'}</span>
              </label>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {privileges.map((priv) => (
                <label
                  key={priv.id}
                  className="inline-flex items-center space-x-2 text-sm text-gray-700"
                >
                  <input
                    type="checkbox"
                    className="form-checkbox text-blue-600"
                    checked={selectedPermissions.includes(String(priv.id))}
                    onChange={() => togglePermission(String(priv.id))}
                       disabled={!['7', '6', '8', '9'].includes(userConfig.grole)}
                  />
                  <span>{priv.privilege}</span>
                </label>
              ))}
            </div>
          </div>
        );
      })}

      <div className="text-left">
        <button
        onClick={handleUpdate}
        disabled={!['7', '6', '8', '9'].includes(userConfig.grole)}
        className={`px-4 py-2 rounded-lg text-white ${
          ['7', '6', '8', '9'].includes(userConfig.grole)
            ? 'bg-[#155DFC] hover:bg-blue-700'
            : 'bg-gray-400 cursor-not-allowed'
        }`}
      >
          Update Privileges
        </button>
      </div>
       <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 999 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
    </div></>
  );
};

export default PrivilagesView;
